"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../../KESI2/KesiConstants");

var _RemoteControlService = require("../../../../../KESI2/Services/RemoteControlService");

var _Nugget = _interopRequireDefault(require("../Nugget.scss"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../../KESI2/KESI2Helper"));

var _Spinner = _interopRequireDefault(require("../../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../../KESI2/Stores/DataStore2"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select/Select"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _DrupalQDNugget = _interopRequireDefault(require("./DrupalQDNugget.scss"));

var _reactSimplePieChart = _interopRequireDefault(require("react-simple-pie-chart"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _Question = _interopRequireDefault(require("../../../Equizzer/Question2"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../../../NavigationManagerCordova"));

var _BuildConstants = require("../../../../../utils/BuildConstants");

var _RegisterInstance = _interopRequireDefault(require("../../../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../../../utils/HttpRequest");

var _QdNugget = _interopRequireDefault(require("../../../../../KESI2/entities/nuggets/QdNugget"));

var _QuizStrings = require("../../../Equizzer/QuizStrings");

var _MuiAlertHelper = require("../../../../../helpers/MuiAlertHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../../helpers/DeviceInfoHelper"));

var _ScreenHelper = _interopRequireDefault(require("../../../../../helpers/ScreenHelper"));

var _UserService = _interopRequireDefault(require("../../../Equizzer/services/UserService"));

var _QuizModeChooser = require("../../../Equizzer/QuizModeChooser");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var CATEGORYINFO_URL = 'rest/api/v1/equeoqdUser/learningState';
var QUESTIONGET_URL = 'rest/api/v1/equeoqdSinglePlay/getQuestions';
var ANSWERSTORE_URL = 'rest/api/v1/equeoqdSinglePlay/storeAnswer';
var DOM_PREFIX = 'qdContainer_';
var QUESTION_BOX = 'questionBox';
var TEST_CATEGORIES = [{
  name: 'SICHERHEIT BEIM FAHREN',
  learned: 0,
  inProgess: 0,
  questionCount: 34
}, {
  name: 'SICHERHEIT AM UND IM AUTO',
  learned: 0,
  inProgess: 0,
  questionCount: 131
}, {
  name: 'SICHER FAHREN',
  learned: 0.1,
  inProgess: 0.3,
  questionCount: 40
}, {
  name: 'UNFÄLLE',
  learned: 0,
  inProgess: 0,
  questionCount: 301
}];
var TEST_QUESTIONS = [{
  answers: [{
    answer: 'Nur auf der Hutablage im Heckbereich',
    isCorrect: false,
    number: 1
  }, {
    answer: 'Auf dem Fahrer- und Beifahrersitz',
    isCorrect: false,
    number: 3
  }, {
    answer: 'Nur hinter der Windschutzscheibe',
    isCorrect: false,
    number: 0
  }, {
    answer: 'Hinter der Windschutzscheibe und auf der Hutablage',
    isCorrect: true,
    number: 2
  }],
  category: {
    name: 'SICHER FAHREN'
  },
  detailedFeedback: {
    0: {
      html: 'Laut StVO muss der Parkschein gut lesbar ausgelegt sein. Das ist er hier zwar, aber es ist nicht der einzige Ort. Die richtige Antwort war „Hinter der Windschutzscheibe und auf der Hutablage“.'
    },
    1: {
      html: 'Laut StVO muss der Parkschein gut lesbar ausgelegt sein. Das ist er hier zwar, aber es ist nicht der einzige Ort. Die richtige Antwort war „Hinter der Windschutzscheibe und auf der Hutablage“.'
    },
    3: {
      html: 'Laut StVO muss der Parkschein gut lesbar ausgelegt sein. Das ist er hier zwar, aber es ist nicht der einzige Ort. Die richtige Antwort war „Hinter der Windschutzscheibe und auf der Hutablage“.'
    }
  },
  duration: 30,
  feedback: 'Schade! Nicht richtig. <b>&bdquo;Hinter der Windschutzscheibe und auf der Hutablage&ldquo;</b> wäre die richtige Antwort gewesen.',
  id: 'sanoficar3 - 940172',
  learningDistance: {
    target: 2,
    current: null,
    history: ''
  },
  number: 3,
  question: 'Wo ist das Ablegen von Parkscheinen laut gängiger Rechtsprechung in Ordnung? <img src="https://fracht.equeo.de/c2_3e2efd27ee5cb41f341f35488b2a02d4.jpg" style="width: 100%; position: absolute; bottom: 0; left: 0; height: auto" />',
  score: 1
}, {
  answers: [{
    answer: 'Der krasse Temperaturunterschied und die kühle Zugluft können zu Erkältungen führen',
    isCorrect: false,
    number: 2
  }, {
    answer: 'Die Innenluft des Wagens wird völlig entfeuchtet und reizt die Schleimhäute der oberen Atemwege',
    isCorrect: false,
    number: 0
  }, {
    answer: 'Der Spritverbrauch steigt',
    isCorrect: false,
    number: 1
  }, {
    answer: 'Alles Genannte',
    isCorrect: true,
    number: 3
  }],
  category: {
    name: 'SICHER FAHREN'
  },
  detailedFeedback: {},
  duration: 10,
  feedback: '',
  id: 'sanoficar2 - 940034',
  learningDistance: {
    target: 2,
    current: null,
    history: ''
  },
  number: 0,
  question: 'Womit müssen Sie rechnen, wenn Sie bei 30°C Außentemperatur die Klimaanlage Ihres Wagens auf 18°C einstellen?  <img src="https://fracht.equeo.de/c2_2e69582bb554f67b28b97ed54d975f07.jpg" style="width: 100%; position: absolute; bottom: 0; left: 0; height: auto">',
  score: 1
}, {
  answers: [{
    answer: '150 bis 400 m',
    isCorrect: true,
    number: 2
  }, {
    answer: '75 bis 150 m',
    isCorrect: false,
    number: 1
  }, {
    answer: '20 bis 50 m',
    isCorrect: false,
    number: 0
  }, {
    answer: '1000 m',
    isCorrect: false,
    number: 3
  }],
  category: {
    name: 'SICHER FAHREN'
  },
  detailedFeedback: {},
  duration: 30,
  feedback: 'Die zutreffende Antwort wäre <b>&bdquo;150 bis 400 m&ldquo;</b> gewesen.',
  id: 'sanoficar2 - 920182',
  learningDistance: {
    target: 2,
    current: null,
    history: ''
  },
  number: 1,
  question: 'In ungefähr welcher Entfernung soll das Warndreieck bei einem Unfall auf der Autobahn aufgestellt werden? <img src="https://fracht.equeo.de/c2_2e69582bb554f67b28b97ed54d975f07.jpg" style="width: 100%; position: absolute; bottom: 0; left: 0; height: auto" />',
  score: 1
}];

var DrupalQdSinglePlayerNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalQdSinglePlayerNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalQdSinglePlayerNugget);

  function DrupalQdSinglePlayerNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalQdSinglePlayerNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "update", function () {
      _this.forceUpdate();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var groupId, token;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MODE, _QuizModeChooser.QUIZ_PLAYMODES.SINGLE_PLAYER);

            case 2:
              groupId = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID];
              console.log('getGroupData', _this.state.data);

              if (!groupId) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return _RegisterInstance["default"].getAccessToken('quizUser:read');

            case 7:
              token = _context.sent;
              _context.next = 10;
              return _UserService["default"].getAllUsersAndLoadTheme(groupId, 'Bearer ' + token);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToNextQuestionOneQuestionPerRound", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(answer) {
        var nextIndex;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.storeAnswerToServer(_this.state.question.id, _this.state.selectedCategory, answer);

              case 2:
                _this.getQuestionsFromServer(_this.state.selectedCategory);

                nextIndex = _this.state.questionIndex + 1;

                _this.setState({
                  questionIndex: nextIndex,
                  question: _this.state.questionList[nextIndex]
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToNextQuestion", function (answer) {
      console.log('DrupalQdNugget.goToNextQuestion answer was', answer, _this.state.question, _this.state.selectedCategory);

      _this.storeAnswerToServer(_this.state.question.id, _this.state.selectedCategory, answer);

      var currentIndex = _this.state.questionIndex;

      if (currentIndex + 1 < _this.state.questionList.length) {
        var nextIndex = currentIndex + 1;
        console.log('DrupalQdNugget.goToNextQuestion next:', currentIndex, nextIndex, _this.state.questionList.length, _this.state.questionList);

        _this.setState({
          questionIndex: nextIndex,
          question: _this.state.questionList[nextIndex]
        }); // if last question -> get new questions from server!


        if (nextIndex === _this.state.questionList.length - 1) {
          console.log('DrupalQdNugget.goToNextQuestion must fetch new questions');

          _this.getQuestionsFromServer(_this.state.selectedCategory);
        }
      } else {
        console.log('DrupalQdNugget.goToNextQuestion must fetch new questions');

        _this.getQuestionsFromServer(_this.state.selectedCategory);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "handleChange", function (event) {
      _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY, event.target.value, false);

      _this.setState({
        selectedCategory: event.target.value
      }); // get questions for this category from server


      _this.getQuestionsFromServer(event.target.value);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToQuestion", function () {
      var el = document.getElementById('lecture_scroll_frame');
      var el2 = document.getElementById(_this.getDomId());

      if (el && el2) {
        setTimeout(function () {
          el.scrollTop = el2.offsetTop - 10;
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderQuestion", function (parentDomId) {
      if (!_this.state.question || !_this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY]) {
        return null;
      }

      var question = _this.state.question;
      var nugget = _this.state.content[_this.props.id];

      var getHeaderHeightForKesi = function getHeaderHeightForKesi() {
        var headerFrameId = "headerContainer";
        var headerEl = document.getElementById(headerFrameId);

        if (headerEl) {
          return headerEl.offsetHeight;
        } else return 0;
      };

      var getLecturePaddingHeightForKesi = function getLecturePaddingHeightForKesi() {
        var lecturePaddingId = "lecturePadding";
        var lecturePaddingElement = document.getElementById(lecturePaddingId);
        if (lecturePaddingElement) return lecturePaddingElement.offsetHeight;else return 0;
      };

      var navBarHeight = _cssConstants["default"].navBarHeight;
      var clientHeight = document.documentElement.clientHeight;
      var headerHeight = getHeaderHeightForKesi();
      var lecturePaddingHeight = getLecturePaddingHeightForKesi();
      var questionBoxHeight = clientHeight - navBarHeight - headerHeight - lecturePaddingHeight;
      var questionBoxMinHeight = isNaN(_cssConstants["default"].questionBoxMinHeight) ? 0 : _cssConstants["default"].questionBoxMinHeight;
      console.log('STYLING STUFF: ', questionBoxHeight > questionBoxMinHeight, questionBoxHeight, questionBoxMinHeight, navBarHeight, clientHeight, headerHeight);
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: QUESTION_BOX,
        style: {
          height: questionBoxHeight > questionBoxMinHeight ? questionBoxHeight : questionBoxMinHeight
        },
        className: _DrupalQDNugget["default"].questionBox
      }, /*#__PURE__*/_react["default"].createElement(_Question["default"], {
        question: question,
        sequences: {},
        onSubmitAnswer: _config["default"].oneQuestionPerRound ? _this.goToNextQuestionOneQuestionPerRound : _this.goToNextQuestion,
        isSinglePlayer: true,
        isInKesi: true,
        parentDomId: parentDomId,
        hasChooser: nugget.showChooser,
        disableTimer: nugget.disableTimer
      }));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderCategoryState", function (listCategory) {
      var category = _this.state.categoryList.find(function (category) {
        return category.name === listCategory;
      });

      console.log('DrupalQdNugget.renderCategoryState: ', category, listCategory, _this.state);
      var icon = category.icon ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _DrupalQDNugget["default"].categoryIcon,
        src: category.icon
      }) : null;
      var learned = category.learned || 0;
      var inProgress = category.inProgess || 0;
      var untouched = 1.0 - learned - inProgress;

      var learningProgressPie = /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQDNugget["default"].learningProgressPie
      }, /*#__PURE__*/_react["default"].createElement(_reactSimplePieChart["default"], {
        borderWidth: 2,
        borderColor: "white",
        slices: [{
          color: 'rgba(0,0,0,0)',
          value: untouched
        }, {
          color: '#FD6A20',
          value: inProgress
        }, {
          color: '#fd0039',
          value: learned
        }]
      }));

      var descriptionButton = category.description ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQDNugget["default"].descriptionButton // onTouchTap={() => showCategoryDescription(this.state.data[DATA_STORE_PATHS.QD_LEARNING_STATE], category, true, true)}

      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: require('../assets/info.svg'),
        style: {
          height: 30
        }
      })) : null;
      var questionCount = category.questionCount ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _DrupalQDNugget["default"].questionCount
      }, category.questionCount, " Fragen") : null;
      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        key: "category_".concat(category.name),
        className: "".concat(_DrupalQDNugget["default"].categoryContainer, " ").concat(icon ? _DrupalQDNugget["default"].withIcon : '')
      }, icon, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQDNugget["default"].categoryName
      }, category.name), descriptionButton, /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQDNugget["default"].bottomInfo
      }, learningProgressPie, questionCount));
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderCategoryHeader", function () {
      if (!_this.state.selectedCategory) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQDNugget["default"].categoryHeader
      }, _this.renderCategoryState(_this.state.selectedCategory));
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      selectedCategory: '',
      categoryList: [],
      waitingForQuestions: false,
      questionList: [],
      question: null,
      questionIndex: -1,
      showLearnedAlert: false,
      hideRubricLearned: false
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _QdNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalQdSinglePlayerNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID, _DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID, _DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalQdSinglePlayerNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _QdNugget["default"].CLASS, this.getDomId()); // get Categories from Server

      this.getCategoriesFromServer();
      this.getGroupData(); // const playgroupId = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.QD_GROUP_ID)
      // const userAuth = DataStore.getElementByPathImmediately(DATA_STORE_PATHS.QD_USER_AUTH_AUTH)
      // console.log('qdsingleplayernugget', playgroupId, userAuth)
      // UserService.getAllUsersAndLoadTheme(playgroupId, userAuth)

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().addOnWindowSizeChangedListener(this.update);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        _ScreenHelper["default"].instance().removeOnWindowSizeChangedListener(this.update);
      }

      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQdSinglePlayerNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "getCategoriesFromServer",
    value: function () {
      var _getCategoriesFromServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var token, response, nugget, category;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _RegisterInstance["default"].getAccessToken('quizUser:read');

              case 2:
                token = _context3.sent;
                _context3.next = 5;
                return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.QUIZZER_HOST, "/").concat(CATEGORYINFO_URL), {}, null, 60000, 10, 'Bearer ' + token);

              case 5:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 20;
                  break;
                }

                if (!(response.status && response.status === 200 && response.data && response.data.length)) {
                  _context3.next = 20;
                  break;
                }

                this.setState({
                  categoryList: response.data[0].rubrics
                });
                nugget = this.state.content[this.props.id];

                if (!(!nugget.showChooser && nugget.categories && nugget.categories.length === 1)) {
                  _context3.next = 19;
                  break;
                }

                console.log('getCategoriesFromServer', response.data[0].rubrics, nugget.categories[0]);
                category = response.data[0].rubrics.find(function (category) {
                  return category.name === nugget.categories[0].value;
                });

                if (category) {
                  _context3.next = 15;
                  break;
                }

                return _context3.abrupt("return");

              case 15:
                console.log('getCategoriesFromServer', category);

                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY, category.name, false);

                this.setState({
                  selectedCategory: category.name
                }); // get questions for this category from server

                this.getQuestionsFromServer(category.name);

              case 19:
                console.log('DrupalQdNugget.getCategoriesFromServer set ', response.data[0].rubrics, this.state.categoryList);

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCategoriesFromServer() {
        return _getCategoriesFromServer.apply(this, arguments);
      }

      return getCategoriesFromServer;
    }()
    /*
    componentWillUpdate (newProps, newState) {
      // console.log('DrupalQdNugget.componentWillUpdate', newProps, newState)
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
       if (this.state.data[DATA_STORE_PATHS.QD_SELECTED_CATEGORY] !== newState.data[DATA_STORE_PATHS.QD_SELECTED_CATEGORY]) {
        newState.selectedCategory = newState.data[DATA_STORE_PATHS.QD_SELECTED_CATEGORY]
        newState.questionList = []
        newState.questionIndex = -1
        newState.question = null
      }
    }
    */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQdSinglePlayerNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;
      var updatedState = {};

      if (this.state.waitingForActivation && active !== this.active) {
        updatedState.waitingForActivation = false;
      }

      if (prevState.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY] !== this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY]) {
        updatedState.selectedCategory = this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY];
        updatedState.questionList = [];
        updatedState.questionIndex = -1;
        updatedState.question = null;
      }

      this.setState(updatedState);
    }
  }, {
    key: "storeAnswerToServer",
    value: function () {
      var _storeAnswerToServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(questionId, rubric, answer) {
        var _this2 = this;

        var subjects, subjectId, jsonObj, token, response, _rubric, categories, okButton, resumeButton;

        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                subjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_SUBJECTS);
                subjectId = subjects[0].id;
                jsonObj = {
                  questionId: questionId,
                  answer: {
                    number: this.state.question.number,
                    value: answer,
                    points: this.state.question.score,
                    approx: null
                  },
                  rubric: rubric,
                  countPoints: this.props.countPoints,
                  affectLearnState: this.props.affectLearnState,
                  subject: subjectId
                };
                console.log('QUESTION: ' + (0, _stringify["default"])(this.state.question));
                _context4.next = 6;
                return _RegisterInstance["default"].getAccessToken('quizGame:write');

              case 6:
                token = _context4.sent;
                _context4.next = 9;
                return (0, _HttpRequest.httpPostJsonEncoded)("".concat(_BuildConstants.QUIZZER_HOST, "/").concat(ANSWERSTORE_URL), jsonObj, null, 60000, 10, 'Bearer ' + token);

              case 9:
                response = _context4.sent;
                console.log('STORETOSERVER: ' + (0, _stringify["default"])(response));

                if (response) {
                  if (response.status && response.status === 200 && response.data && response.data.success) {
                    _rubric = response.data.rubric;
                    categories = this.state.categoryList.map(function (category) {
                      return category.name === _rubric.name ? _rubric : category;
                    });
                    console.log('rubric', response, _rubric.name.replace(/[^a-zA-Z0-9]+/g, ''));

                    _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.QD_MY_LEARNING_STATE, ".").concat(_rubric.name.replace(/[^a-zA-Z0-9]+/g, '')), _rubric.learned);

                    if (_rubric.learned === 1 && !this.state.hideRubricLearned) {
                      // TODO: save somewhere, that this category is learned for some kind of precondition
                      okButton = {
                        label: (0, _QuizStrings.getString)('TO_QUIZ_HOME'),
                        callback: function callback() {
                          return _NavigationManagerCordova["default"].goBack();
                        }
                      };
                      resumeButton = {
                        label: (0, _QuizStrings.getString)('NEXT'),
                        callback: function callback() {
                          _this2.setState({
                            hideRubricLearned: true
                          });
                        }
                      };
                      (0, _MuiAlertHelper.showWideAlertReact)( /*#__PURE__*/_react["default"].createElement("p", null, "Sehr gut! Sie haben die Kategorie ", /*#__PURE__*/_react["default"].createElement("b", null, _rubric.name), " vollst\xE4ndig gelernt!"), null, 'Sehr gut!', true, [okButton, resumeButton]);
                    }

                    this.setState({
                      categoryList: categories
                    });
                    console.log('DrupalQdNugget.storeAnswerToServer setted ', response.data);
                  }
                }

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function storeAnswerToServer(_x2, _x3, _x4) {
        return _storeAnswerToServer.apply(this, arguments);
      }

      return storeAnswerToServer;
    }()
  }, {
    key: "getQuestionsFromServer",
    value: function () {
      var _getQuestionsFromServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(rubric) {
        var subjects, subjectId, token, response, oldQuestions, newQuestions, newIndex;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                subjects = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_SUBJECTS);
                subjectId = subjects[0].id;

                if (!this.state.waitingForQuestions) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return");

              case 4:
                this.setState({
                  waitingForQuestions: true
                });
                _context5.prev = 5;
                _context5.next = 8;
                return _RegisterInstance["default"].getAccessToken('quizGame:read');

              case 8:
                token = _context5.sent;
                _context5.next = 11;
                return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.QUIZZER_HOST, "/").concat(QUESTIONGET_URL), {
                  rubric: rubric,
                  subject: subjectId
                }, null, false, 60000, 10, 'Bearer ' + token);

              case 11:
                response = _context5.sent;

                if (!response) {
                  _context5.next = 22;
                  break;
                }

                console.log('resp log: ' + (0, _stringify["default"])(response));

                if (!(response.status && response.status === 200 && response.data && response.data.success)) {
                  _context5.next = 22;
                  break;
                }

                oldQuestions = this.state.questionList.slice();
                newQuestions = oldQuestions.concat(response.data.questions);
                newIndex = this.state.questionIndex === -1 ? 0 : this.state.questionIndex;
                this.setState({
                  waitingForQuestions: false,
                  questionList: newQuestions,
                  questionIndex: newIndex,
                  question: newQuestions[newIndex]
                });
                console.log('StateQuestionList: ', (0, _stringify["default"])(this.state.questionList));
                console.log('DrupalQdNugget.getQuestionsFromServer set ', response.data);
                return _context5.abrupt("return");

              case 22:
                if (this.state.questionIndex === -1 || this.state.questionList.length === 0) {
                  (0, _MuiAlertHelper.showAlertWithOptions)({
                    title: (0, _QuizStrings.getString)('ERROR'),
                    message: (0, _QuizStrings.getString)('NO_QUESTIONS_FROM_SERVER')
                  });
                }

                _context5.next = 29;
                break;

              case 25:
                _context5.prev = 25;
                _context5.t0 = _context5["catch"](5);
                console.log('error getting questions from the server', _context5.t0);
                (0, _MuiAlertHelper.showAlertWithOptions)({
                  title: (0, _QuizStrings.getString)('ERROR'),
                  message: (0, _QuizStrings.getString)('NO_QUESTIONS_FROM_SERVER')
                });

              case 29:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 25]]);
      }));

      function getQuestionsFromServer(_x5) {
        return _getQuestionsFromServer.apply(this, arguments);
      }

      return getQuestionsFromServer;
    }()
  }, {
    key: "renderCategoryChooser",
    value: function renderCategoryChooser(nugget) {
      var _this3 = this;

      if (!nugget || !nugget.showChooser) {
        return null;
      }

      var categoriesToShow = this.state.categoryList;
      return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        className: _DrupalQDNugget["default"].chooser
      }, /*#__PURE__*/_react["default"].createElement(_InputLabel["default"], {
        htmlFor: "category"
      }, (0, _QuizStrings.getString)('CHOOSE_CATEGORY')), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
        className: _DrupalQDNugget["default"].select,
        value: this.state.selectedCategory,
        onChange: this.handleChange,
        inputProps: {
          name: 'category',
          id: 'category'
        }
      }, categoriesToShow.map(function (category) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          className: _DrupalQDNugget["default"].menuItem,
          key: category.name,
          value: category.name
        }, _this3.renderCategoryState(category.name));
      })));
    }
  }, {
    key: "render",
    value: function render() {
      /**
       * @type {QdNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var categories = nugget.categories && nugget.categories.length ? nugget.categories.map(function (cat) {
        return cat.value;
      }) : []; // temporarily without filter
      // const categoriesToShow = categories.length ? this.state.categoryList.filter(category => categories.indexOf(category.name) > -1) : this.state.categoryList

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames, " ").concat(_DrupalQDNugget["default"].greyBackground),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, this.renderCategoryChooser(nugget), /*#__PURE__*/_react["default"].createElement("div", {
        id: 'lets_see_if_this_element_is_useful'
      }, this.renderQuestion('lets_see_if_this_element_is_useful'))));
    }
  }]);
  return DrupalQdSinglePlayerNugget;
}(_KESI2BasicComponent["default"]);

DrupalQdSinglePlayerNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired
};
DrupalQdSinglePlayerNugget.defaultProps = {
  id: null
};
var _default = DrupalQdSinglePlayerNugget;
exports["default"] = _default;